export default{
    state:{
        event_source: undefined,
        connection: true,
        sync_error: undefined
    },
    mutations:{
        set_event_source(state, value){
            state.event_source = value
        },
        drop_event_source(state) {
            if (state.event_source) {
                state.event_source.close()
            }
            state.event_source = undefined
        },
        set_connection(state, value){
            state.connection = value
        },
        set_sync_status(state, value){
            state.sync_status = value
        },
        set_sync_error(state, value){
            state.sync_error = value
        }
    },
    actions:{
        async parse_event_data(_, evt) {
            return JSON.parse(evt.data)
        },
        async init_stream({dispatch, commit, getters}){
            let event_source
            try{
                event_source = new EventSource(`${getters.url}/api/int/sse/subscribe?dlv_auth=${getters.token}`)
            }catch(e){
                dispatch('throwTimeoutMessage', {
                    text: `(${e.error_class}) ${e.message}`,
                    message_class: 'error'
                })
            }
            commit('set_event_source', event_source)

            event_source.addEventListener('error', (e)=>{dispatch('stream_error', e)})
            event_source.addEventListener('open', (e)=>{dispatch('stream_on', e)})
            event_source.addEventListener('ConfigChangedEvent', (e)=>{dispatch('modify_config', e)})
            event_source.addEventListener('LocalRefsChangedEvent', (e) => {dispatch('modify_local_refs', e)})
            event_source.addEventListener('OrderChangedEvent', (e)=>{dispatch('update_order', e)})
            event_source.addEventListener('NewOrderEvent', (e)=>{dispatch('new_order', e)})
            event_source.addEventListener('DropConnectionEvent', (e) =>  dispatch('drop_connection', e) )
            event_source.addEventListener('PhoneRingEvent', (e) =>  dispatch('phone_ring', e))
        },
        async stream_on({commit}){
            await commit('set_connection', true)
            await commit('set_sync_error', undefined)
        },
        async stream_off(ctx){
            ctx.state.event_source.close()
            ctx.commit('set_event_source', undefined)
        },
        async stream_error({commit, getters}){
            const $t = getters.localePhrase
            await commit('set_sync_error', $t('Потеряно соединение с сервером ProDelivery'))
            await commit('set_connection', false)
        },
        async drop_connection({dispatch, commit}, e) {
            let evt = await dispatch('parse_event_data', e)

            await commit('set_sync_error', evt.reason)
            await commit('drop_event_source')
            await commit('set_connection', false)
            if (evt.logout) {
                await dispatch('logout')
            }
        },
        async modify_config({dispatch, commit}, e){
            let config = await dispatch('parse_event_data', e)
            await commit('setConfigServer', config)
        },
        async modify_local_refs({dispatch, commit}, e){
            let local_refs = await dispatch('parse_event_data', e)
            await commit('setLocalRefs',local_refs)
        },
        async new_order({dispatch,commit, getters}, e){
            let order = await dispatch('parse_event_data', e)
            if(!getters.orderById(order.id)){
                await commit('insertOrder', order)
            }
        },
        async update_order({dispatch, commit, getters},e){
            let order = await dispatch('parse_event_data', e)
            if(!getters.orderById(order.id)){
                await commit('insertOrder', order)
            }else{
                await commit('updateOrder', order)
            }
        },
        async phone_ring({ dispatch }, e){
            await dispatch('throwTimeoutMessage',
                {
                    type: 1,
                    message_data: await dispatch('parse_event_data', e),
                    message_class: 'success',
                    timeout: 60000
                } 
            )
        }
    },
    getters:{
        event_source(state){
            return state.event_source
        },
        connection(state){
            return state.connection
        },
        sync_error(state){
            return state.sync_error
        }
    }
}